.locationField {
  margin-top: 16px;
}

.datePicker {
  width: 100%;
  margin-top: 32px;
}

.allDayControl {
  padding-top: 16px;
  padding-bottom: 16px;
}

.timeRow {
  display: flex;
  padding-top: 16px;
  padding-bottom: 16px;
  flex-direction: row;
}

.divider {
  padding-top: 16px;
  padding-bottom: 16px;
}
